import { motion } from 'motion/react'
import { PackageOpen } from 'lucide-react'
import { SetCard } from '@/entities/product/ui/set-card'
import { ProductCardSkeleton } from '@/shared/ui/skeleton'
import type { ProductSet } from '@/entities/product'

export interface CatalogSetsGridProps {
  sets: ProductSet[]
  isLoading?: boolean
  skeletonCount?: number
}

/**
 * Виджет: Сетка подарочных наборов для каталога.
 * Плоский список без категорий/группировки (наборы не категоризируются).
 */
export function CatalogSetsGrid({ sets, isLoading, skeletonCount = 4 }: CatalogSetsGridProps) {
  if (isLoading) {
    return (
      <div className="px-4 grid grid-cols-2 gap-4 gap-y-5 w-full">
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    )
  }

  if (sets.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        className="px-4 py-16 text-center"
      >
        <div className="mx-auto w-16 h-16 rounded-full bg-gray-100 dark:bg-dark-elevated flex items-center justify-center mb-4">
          <PackageOpen className="w-8 h-8 text-gray-400" />
        </div>
        <h3 className="text-base font-semibold text-ink dark:text-white mb-1">
          Наборов пока нет
        </h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 max-w-xs mx-auto">
          Загляните позже — мы собираем новые подарочные комплекты.
        </p>
      </motion.div>
    )
  }

  return (
    <div className="px-4 grid grid-cols-2 gap-4 gap-y-5 w-full">
      {sets.map((set, index) => (
        <motion.div
          key={set.id}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25, delay: Math.min(index * 0.04, 0.4) }}
        >
          <SetCard set={set} />
        </motion.div>
      ))}
    </div>
  )
}
